export class ApiResponseUtils {

    static extractList<T = any>(res: any): T[] {
        return Array.isArray(res) ? res : res?.results ?? [];
    }

    static isPaginated(res: any): boolean {
        return !Array.isArray(res) && 'results' in res;
    }

    static extractPagination(res: any): { count: number; next: string | null; previous: string | null } {
        return {
            count: res?.count ?? 0,
            next: res?.next ?? null,
            previous: res?.previous ?? null
        };
    }

}